/** @jsx jsx */
import { Fragment, useState } from 'react'
import { jsx } from 'theme-ui'
import Modal from 'react-modal'

const customModalStyles = {
  overlay: {
    backgroundColor: 'rgba(20, 20, 20, 0.2)',
    zIndex: 9999999
  },
  content: {
    border: 'none',
    backgroundColor: 'transparent',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
}

const ModalPopUp = ({
  name,
  title,
  imgUrl,
  winnersLogoModal,
  awardTitle,
  awardLabel,
  awardDescription,
  awardSecondaryDescription,
  providerLink,
  quote,
  awardReason,
  ctaTitle,
  onClick,
  variant,
  noFollow = false
}) => (
  <div
    sx={{
      background: '#FFFFFF',
      width: '100%',
      p: ['16px', '32px 24px'],
      borderRadius: 8,
      height: '100%',
      position: 'relative',
      maxWidth: ['100%', '800px']
    }}
  >
    <div sx={{ display: 'flex', justifyContent: 'right' }}>
      <div
        sx={{
          fontSize: 24,
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        X
      </div>
    </div>
    <div sx={{ my: 16 }}>
      {winnersLogoModal}
      <h3 sx={{ fontSize: 32, my: 16 }}>{awardTitle}</h3>
      {awardLabel}
      <p
        sx={{
          fontWeight: 400,
          fontSize: '18px',
          lineHeight: '24px',
          my: '16px'
        }}
      >
        {awardDescription}
      </p>
      {awardSecondaryDescription && (
        <p
          sx={{
            fontWeight: 400,
            fontSize: '18px',
            lineHeight: '24px',
            my: '16px',
            fontStyle: 'italic'
          }}
        >
          {awardSecondaryDescription}
        </p>
      )}
      {!!ctaTitle && !!providerLink && (
        <div sx={{ display: 'flex', justifyContent: 'right' }}>
          <a
            href={providerLink}
            target="_blank"
            rel={noFollow ? 'nofollow noreferrer' : 'noreferrer'}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              p: 12,
              color: 'white',
              background: '#141424',
              maxWidth: ['100%', 264]
            }}
          >
            {ctaTitle}
          </a>
        </div>
      )}
    </div>
  </div>
)

const ModalPopupLink = ({
  text = 'Find out more',
  modalContentId,
  modalContent,
  variant,
  noFollow
}) => {
  const [modalIsOpen, setIsOpen] = useState(false)
  const [currentModalContent, setCurrentModalContent] = useState({})

  Modal.setAppElement('#app')
  const openModal = () => {
    setCurrentModalContent(modalContent)
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <Fragment>
      <a
        sx={{
          textDecoration: 'underline',
          '&:hover': {
            cursor: 'pointer'
          }
        }}
        onClick={openModal}
      >
        {text}
      </a>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
      >
        <ModalPopUp
          onClick={closeModal}
          {...currentModalContent}
          variant={variant}
        />
      </Modal>
    </Fragment>
  )
}

export default ModalPopupLink
